import type { SearchHistoryMode } from '@/contexts/PlutoContext';

export type SearchHistory = Record<SearchHistoryMode, string[]>;

const EMPTY_SEARCH_HISTORY: SearchHistory = { target: [], driver: [], userAccessControl: [] };

function normalizeHistoryItems(value: unknown): string[] {
  if (!Array.isArray(value)) return [];
  return value.filter((item): item is string => typeof item === 'string');
}

export function normalizeSearchHistory(value: unknown): SearchHistory {
  if (Array.isArray(value)) {
    return {
      target: normalizeHistoryItems(value),
      driver: [],
      userAccessControl: [],
    };
  }

  if (!value || typeof value !== 'object') return EMPTY_SEARCH_HISTORY;

  const searchHistory = value as Partial<Record<SearchHistoryMode, unknown>>;
  return {
    target: normalizeHistoryItems(searchHistory.target),
    driver: normalizeHistoryItems(searchHistory.driver),
    userAccessControl: normalizeHistoryItems(searchHistory.userAccessControl),
  };
}
